import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  getTransactionData,
  getTransactionHistory,
  getTransactionHistoryConvera,
  getTransactionHistoryOther,
} from "../../../services/history";
import { HistoryListRequestPayload, historyActions } from "./historySlice";

const mapTabForApi = (selectedTab: string) => {
  if (selectedTab === "Travel Card") {
    return "TravelCard";
  }
  return selectedTab;
};

const getHistoryErrorMessage = (err: any) => {
  const errorType = err?.response?.data?.error?.type || "";
  if (errorType === "missing servlet Request Parameter") {
    return "Please select the date range";
  }
  return errorType || "Failed to fetch transactions. Please try again";
};

function* fetchHistoryList(action: PayloadAction<HistoryListRequestPayload>): any {
  const { selectedTab, ...rest } = action.payload;
  try {
    const body = {
      ...rest,
      ...(selectedTab !== "Online" && { tab: mapTabForApi(selectedTab) }),
    };

    const response =
      selectedTab === "Online"
        ? yield call(getTransactionHistory, body)
        : selectedTab === "Convera"
        ? yield call(getTransactionHistoryConvera, body)
        : yield call(getTransactionHistoryOther, body);

    const data = response?.data || {};
    yield put(
      historyActions.fetchHistoryListSucceeded({
        content: data.content || [],
        size: data.size ?? rest.size,
        totalElements: data.totalElements ?? 0,
        totalPages: data.totalPages ?? 0,
      })
    );
  } catch (err: any) {
    yield put(historyActions.fetchHistoryListFailed(getHistoryErrorMessage(err)));
  }
}

function* fetchHistoryDetail(action: PayloadAction<any>): any {
  const { selectedTab, transactionId, transactions } = action.payload;
  try {
    if (selectedTab === "Online") {
      const response = yield call(getTransactionData, transactionId);
      yield put(historyActions.fetchHistoryDetailSucceeded(response?.data || {}));
      return;
    }

    const data =
      selectedTab === "Convera"
        ? transactions?.find((item: any) => item?.converaReferenceId?.toString() === transactionId)
        : transactions?.find((item: any) => item?.id?.toString() === transactionId);
    yield put(historyActions.fetchHistoryDetailSucceeded(data || {}));
  } catch (err: any) {
    yield put(
      historyActions.fetchHistoryDetailFailed(
        err?.response?.data?.error?.type || "Failed to fetch transaction details."
      )
    );
  }
}

export default function* historySaga() {
  yield takeLatest(historyActions.fetchHistoryListRequested.type, fetchHistoryList);
  yield takeLatest(historyActions.fetchHistoryDetailRequested.type, fetchHistoryDetail);
}
